/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Context_DetectedInputs */



/**
* | output |
* | --- |
* | "Detected automatically. Change it only if you know better." |
*
* @param {Private_Models_Context_DetectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_context_detected = /** @type {((inputs?: Private_Models_Context_DetectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Context_DetectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatisch erkannt. Ändern Sie den Wert nur, wenn Sie es besser wissen.")
	return /** @type {LocalizedString} */ ("Detected automatically. Change it only if you know better.")
});